import { useState, useEffect } from 'react';

const detectIsMobile = (): boolean => {
  const hasTouchScreen =
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    // @ts-expect-error - older browsers
    navigator.msMaxTouchPoints > 0;

  const userAgent = navigator.userAgent.toLowerCase();
  const isMobileUA = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|tablet/i.test(userAgent);

  const isSmallScreen = window.innerWidth < 768;
  return hasTouchScreen && (isMobileUA || isSmallScreen);
};

export const useIsMobile = (): boolean => {
  // Initialise synchronously so callers can safely gate mount-time effects
  // (e.g. token preloads) without briefly treating mobile as desktop.
  const [isMobile, setIsMobile] = useState<boolean>(() => detectIsMobile());

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(detectIsMobile());
    };

    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);

    return () => {
      window.removeEventListener('resize', checkIsMobile);
    };
  }, []);

  return isMobile;
};
